<template>
    <div class="w100" style=" background: #01033c;">
        <article class="content-bg" style="padding-top: 40px;">
            <div class="logo-position">
                <img src="../../assets/images/ej/meetingLogo.png" alt="" srcset="" style="width: 200px">
                <p class="mt30">感谢有你</p>
                <p>共创辉煌</p>
                <div class="mt30"><span></span></div>
                <div><span></span></div>
                <div><span></span></div>
                <div><span></span></div>
            </div>
            <div class="logo-position textRight" style="right: 60px; left: auto;">
                <img src="../../assets/images/ej/meetingLogo.png" alt="" srcset="" style="width: 200px">
                <p class="mt30">感谢有你</p>
                <p>共创辉煌</p>
                <div class="mt30"><span></span></div>
                <div class=""><span></span></div>
                <div class=""><span></span></div>
                <div class=""><span></span></div>
            </div>
            <div class="wContent center">
                <div class="textCenter">
                    <img src="../../assets/images/ej/active2021.png" alt="" srcset="" style="width: 340px;"><br>
                    <img src="../../assets/images/ej/activeTitle.png" alt="" srcset="" style="width: 770px;" class="mt30">
                    <p class="title-text mt40 fontWhite">2021 · 中国 · 广州</p>
                    <!-- <p class="title-text-en mt10 fontWhite">WITHOUT BOUNDARIES</p> -->
                    <p class="time-text textCenter center mt40">时间： 2021年10月22日，地点： 佛山顺德华美达酒店</p>
                </div>
                <div class="center meeting-jj">
                    <p class="textCenter meeting-jj-title">会议简介</p>
                    <p>2021年，钢铁市场和行业进入后疫情时代。国内外需求在疫情后共振复苏，碳达峰和碳中和目标约束,钢铁产能产量双控预期，驱动了上半年壮阔的市场行情，引发了保供稳价的巨大压力。下半年以来市场需求增速整体显著回落，供应抑制对价格的支撑作用突显，在煤、焦、钢、矿等不同环节上供应抑制程度的边际差异，引发了产业链的不平衡，价格强弱的分化。
                        <br>展望四季度，钢铁产业链不平衡因素、市场和行业外部的不确定因素依然很多。在钢铁产能产量双控、能耗双控下，钢材供应显著收缩，需求边际改善的预期能否兑现，煤、电供应缺口修复的进展，成为市场关注的焦点。预期和现实的博弈，政策扰动，疫情反复，将使四季度市场波动率大幅度上升。
                        <br>为了深入研讨四季度市场和行业趋势，发现市场机会，防范市场风险，召开本次论坛，诚邀莅临！</p>
                </div>
                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;会&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;程</span></p>
                    <div class="meeting-yc-content center mt30">
                        <h2>
                            <span>下午</span><br>
                            <span>10月22日</span>
                        </h2>
                        <div class="line"></div>
                        <div>
                            <p class="time-line-content">
                                <span class="fontWhite font14">13:30 - 14:00</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">嘉宾签到</span>
                                <a class="shuline" style="height: 50px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">14:00 - 14:30</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">致辞</span>
                                <span class="right-text">
                                    佛山市钢管行业协会单位佛山市三水振鸿钢制品有限公司（振鸿钢管）总裁
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;曾令均<br>
                                    广东荣钢管道科技有限公司总经理
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;邓伟勤<br>
                                    德天（天津）国际贸易发展有限公司总经理助理&nbsp;&nbsp;&nbsp;&nbsp;郭华利<br>
                                    其他领导致辞
                                </span>
                                <a class="shuline" style="height: 220px;"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">14:30 - 15:10</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    《2021年钢市回顾与后期钢市展望》<br>
                                    <span class="right-intro">河北唐宋大数据产业股份有限公司研究中心部长 徐向南</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">15:10 - 15:40</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    《2021带钢行业整体分析及展望》<br>
                                    <span class="right-intro">天津市新天钢联合特钢有限公司副总经理 李君亮</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">15:40 - 16:20</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    《从制造业角度看板材未来走势》<br>
                                    <span class="right-intro">合肥融达环境技术有限公司数据研究主任专员 余小雯</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">16:20 - 16:30</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    品牌推介 ：《百年源泰，德润人心》<br>
                                    <span class="right-intro">天津源泰德润钢管制造集团有限公司领导</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">16:20 - 16:30</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    品牌推介 ：《打造中国钢管一站式服务模式》<br>
                                    <span class="right-intro">天津友发钢管集团领导</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">16:30 - 17:00</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    《2021坯型市场总结及分析》<br>
                                    <span class="right-intro">广东乐居商贸集团有限公司型材部副总经理 潘志煊</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">17:00 - 17:30</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    《期现货多组合投资策略分析》<br>
                                    <span class="right-intro">河北唐宋大数据产业股份有限公司市场部总经理 范峰博</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">18:00 - 20:00</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">晚宴</span>
                                <!-- <a class="shuline" style="height: 40px"></a> -->
                            </p>
                        </div>                        
                    </div>
                </div>

                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;嘉&nbsp;&nbsp;&nbsp;宾&nbsp;&nbsp;&nbsp;介&nbsp;&nbsp;&nbsp;绍</span></p>
                    <div class="meeting-jbjs center mt40">
                        <el-row :gutter="20" class="mw-modular-box">
                            <el-col :span="8">
                                <div class="textCenter">
                                    <img src="../../assets/images/ej/activity_guangzhou/guohuali.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">德天(天津)国际贸易发展有限公司总经理助理 郭华利</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter">
                                    <img src="../../assets/images/ej/activity_guangzhou/zenglingjun.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">佛山市三水振鸿钢制品有限公司（振鸿钢管）总裁 曾令均</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter">
                                    <img src="../../assets/images/ej/activity_guangzhou/panzhixuan.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">广东乐居商贸集团有限公司型材部副总经理 潘志煊</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/ej/activity_guangzhou/dengweiqin.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">广东荣钢管道科技有限公司总经理 邓伟勤</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/ej/activity_guangzhou/xuxiangnan.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">河北唐宋大数据产业股份有限公司研究中心部长 徐向南</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/ej/activity_guangzhou/lijunliang.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">天津市新天钢联合特钢有限公司副总经理 李君亮</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/ej/activity_guangzhou/yuxiaowen.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">合肥融达环境技术有限公司数据研究主任专员 余小雯</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/ej/activity_guangzhou/fanfengbo.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">河北唐宋大数据产业股份有限公司市场部总经理 范峰博</p>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>

                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;精&nbsp;&nbsp;&nbsp;彩&nbsp;&nbsp;&nbsp;仪&nbsp;&nbsp;&nbsp;式</span></p>
                    <div id="marqueeBox" name="marqueeBox" class="index-quote-list-box">
                        <div class="inlineBlock img-box" @click="showImgDetail(0)">
                            <img src="../../assets/images/ej/activity_guangzhou/yishi1.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(1)">
                            <img src="../../assets/images/ej/activity_guangzhou/yishi2.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(2)">
                            <img src="../../assets/images/ej/activity_guangzhou/yishi3.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(3)">
                            <img src="../../assets/images/ej/activity_guangzhou/yishi4.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(4)">
                            <img src="../../assets/images/ej/activity_guangzhou/yishi5.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(5)">
                            <img src="../../assets/images/ej/activity_guangzhou/yishi6.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(6)">
                            <img src="../../assets/images/ej/activity_guangzhou/yishi7.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(7)">
                            <img src="../../assets/images/ej/activity_guangzhou/yishi8.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(8)">
                            <img src="../../assets/images/ej/activity_guangzhou/yishi9.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(9)">
                            <img src="../../assets/images/ej/activity_guangzhou/yishi10.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(10)">
                            <img src="../../assets/images/ej/activity_guangzhou/yishi11.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(11)">
                            <img src="../../assets/images/ej/activity_guangzhou/yishi12.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(12)">
                            <img src="../../assets/images/ej/activity_guangzhou/yishi13.jpg" alt="" height="150px">
                        </div>
                        <!-- <div class="inlineBlock img-box" @click="showImgDetail(13)">
                            <img src="../../assets/images/ej/activity_guangzhou/yishi14.jpg" alt="" height="150px">
                        </div> -->
                        <div class="inlineBlock img-box" @click="showImgDetail(14)">
                            <img src="../../assets/images/ej/activity_guangzhou/yishi15.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(15)">
                            <img src="../../assets/images/ej/activity_guangzhou/yishi16.jpg" alt="" height="150px">
                        </div>
                    </div>
                    <el-dialog title="" :visible.sync="dialogVisible" width="40%">
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <div>
                                    <img :src="dialogImg" alt="" class="w100">
                                </div>
                            </el-col>
                        </el-row>
                    </el-dialog>
                </div>

                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;会&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;赞&nbsp;&nbsp;&nbsp;助</span></p>
                    <div class="meeting-zanzhu center textCenter">
                        <p class="zanzhu-title mt30">主办单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8" :offset="8">
                                <div class="zanzhu-center">河北唐宋大数据产业股份有限公司</div>
                            </el-col>
                        </el-row>

                        <p class="zanzhu-subtitle mt30">独家冠名</p>
                        <el-row :gutter="20">
                            <el-col :span="8" :offset="8"><!-- :offset="8"-->
                                <div class="zanzhu-center">德天（天津）国际贸易发展有限公司</div>
                            </el-col>
                        </el-row>

                        <p class="zanzhu-subtitle mt30">联合主办</p>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="zanzhu-left">乐从钢铁贸易协会</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">佛山市钢管行业协会</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">广东荣钢管道科技有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">天津源泰德润钢管制造集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">山东大宗商品交易中心</div>
                            </el-col>
                        </el-row>

                        <p class="zanzhu-subtitle mt30">协办单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="zanzhu-left">安丰钢铁集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">河北津西钢铁集团股份有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">汇金钢铁（天津）集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">天津友发钢管集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">佛山市三水振鸿钢管制品有限公司(振鸿钢管）</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">唐山连创制钢科技有限公司</div>
                            </el-col>
                        </el-row>

                        <p class="zanzhu-subtitle mt30">支持单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="zanzhu-left">广西柳州钢铁集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">中国宝武集团广东韶关钢铁有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">广州启润实业有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">广东省广晟冶金集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">苏州裕景泰贸易有限公司广州分公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">佛山强源钢管有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">唐山瑞丰钢铁（集团）有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">唐山京华制管有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">河北天柱钢铁集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">河北东海特钢集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">唐山市德龙钢铁有限公司</div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
            <div class="meeting-yt">
                <p class="meeting-yt-title center textCenter"><span>&nbsp;大&nbsp;&nbsp;&nbsp;会&nbsp;&nbsp;&nbsp;地&nbsp;&nbsp;&nbsp;点</span></p>
                <div class="meeting-address">
                    <div style="margin-top: 40px" class="mw-modular-box fontWhite textCenter">
                        <h3 style="line-height: 40px; font-size: 24px">佛山顺德华美达酒店</h3>
                        <p style="line-height: 40px; font-size:24px">佛山市顺德区乐从镇水藤大道28号</p>
                    </div>
                    <div class="address-bg textCenter">
                        <a href="https://map.baidu.com/search/%E4%BD%9B%E5%B1%B1%E9%A1%BA%E5%BE%B7%E5%8D%8E%E7%BE%8E%E8%BE%BE%E9%85%92%E5%BA%97/@12588981.68,2606233.12,19z?querytype=s&da_src=shareurl&wd=%E4%BD%9B%E5%B1%B1%E9%A1%BA%E5%BE%B7%E5%8D%8E%E7%BE%8E%E8%BE%BE%E9%85%92%E5%BA%97&c=138&src=0&pn=0&sug=0&l=19&b=(12588497.18,2606050.12;12589457.18,2606518.62)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&seckey=e7ccd76a71cca7384bc9d56993ddbed2e19bbff4744b85e39bb3d65be30e7613e76ae0b8689ae7f5bb14207898aef6950e69432a9314fa542a239fa64bfb5b456c8529780f5fb64949992a11105fd4576f81af96a743fc349cbd094f0f27e3881da5782089c40f8a5f093b61e8a8497bc92569954ca37c3bb0230556d83170e26f2a58e21688c540a61c5a97eab803f26e3eef5543bd761f5261c442407d1a2c39a22acabc5f81d75f293772166d20c17a08be04f6699c806eea15493068b713c357a636bded0a2ad8f1e44e86265d107cd0d4609d243d5c05d73e3b98f60555101fcff84fe4757d024ab08e45c502dd&device_ratio=1" target="_blank">
                            <img src="../../assets/images/ej/activity_guangzhou/address.jpg" alt="" srcset="" class="">
                        </a>
                    </div>
                </div>
            </div>
            <div class="meeting-yt">
                <p class="meeting-yt-title center textCenter"><span>&nbsp;会&nbsp;&nbsp;&nbsp;务&nbsp;&nbsp;&nbsp;联&nbsp;&nbsp;&nbsp;系</span></p>
                <div class="meeting-concat center font16 fontWhite mt40">
                    <p class="textCenter" style="line-height: 40px;">
                        河北唐宋大数据产业股份有限公司&nbsp;&nbsp;&nbsp;&nbsp;回执传真至：0315-5921091/92<br>
                        会务联系人：王慧 18231525225&nbsp;&nbsp;&nbsp;&nbsp;王钊 13383152612
                    </p>
                    <el-row style="margin-top: 10px; padding-bottom: 30px;">
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/act_code1.png" alt="" width="100px">
                                <small style="display: block;line-height: 40px;">在线监测预警公众号</small>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/footer_down.png" alt="" width="100px">
                                <p style="line-height: 35px;">唐宋app</p>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/footer_code.png" alt="" width="100px">
                                <p style="line-height: 35px;">唐宋大数据</p>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </article>

        <ConcatsControl></ConcatsControl>
    </div>
</template>
<script>
import $ from 'jquery'
import QRCode from 'qrcode'
import '../../assets/js/jquery.liMarquee.js'
import { baseUrl, getQueryString, adIDs } from '../../assets/js/common'
import ConcatsControl from '../../templates/concatsControl'
export default {
    name: 'activitiesDetail2021gz',
    components: { ConcatsControl },
    data() {
        return {
            // adIDsIndex: [{
            //     name: 'zx39',
            //     id: adIDs['zx39'],
            //     list: []
            // }],
            liMarquee: null,
            dialogVisible: false,
            dialogImg: '',
            imgs: [
                require('../../assets/images/ej/activity_guangzhou/yishi1.jpg'),
                require('../../assets/images/ej/activity_guangzhou/yishi2.jpg'),
                require('../../assets/images/ej/activity_guangzhou/yishi3.jpg'),
                require('../../assets/images/ej/activity_guangzhou/yishi4.jpg'),
                require('../../assets/images/ej/activity_guangzhou/yishi5.jpg'),
                require('../../assets/images/ej/activity_guangzhou/yishi6.jpg'),
                require('../../assets/images/ej/activity_guangzhou/yishi7.jpg'),
                require('../../assets/images/ej/activity_guangzhou/yishi8.jpg'),
                require('../../assets/images/ej/activity_guangzhou/yishi9.jpg'),
                require('../../assets/images/ej/activity_guangzhou/yishi10.jpg'),
                require('../../assets/images/ej/activity_guangzhou/yishi11.jpg'),
                require('../../assets/images/ej/activity_guangzhou/yishi12.jpg'),
                require('../../assets/images/ej/activity_guangzhou/yishi13.jpg'),
                // require('../../assets/images/ej/activity_guangzhou/yishi14.jpg'),
                require('../../assets/images/ej/activity_guangzhou/yishi15.jpg'),
                require('../../assets/images/ej/activity_guangzhou/yishi16.jpg')
            ],
            imgsDetailNames: 
            [
                // ['河北普阳钢铁有限公司', '河北津西钢铁集团股份有限公司', '秦皇岛宏兴钢铁有限公司', '唐山市德龙钢铁有限公司', '山西晋南钢铁集团有限公司', '河北天柱钢铁集团有限公司', '天津荣程联合钢铁集团有限公司', '唐山东华钢铁企业集团有限公司', '河北安丰钢铁有限公司', '江苏徐钢钢铁集团有限公司'], // 钢铁生产企业
                // ['厦门海翼国际贸易有限公司', '浙江物产金属集团有限公司', '中基宁波集团股份有限公司', '成大物产（厦门）有限公司', '浙商中拓集团股份有限公司', '山东天保工贸有限公司', '天津启润投资有限公司', '苏美达国际技术贸易有限公司', '杭州热联集团股份有限公司', '江苏象石实业股份有限公司'], // 综合贸易企业
                // ['新绛天地和金属制品有限公司', '天津市群胜达钢管有限公司', '天津友发钢管集团股份有限公司', '山东舜世高科实业有限公司', 'ZDP正大制管有限公司', '霸州市众丰金属制品有限公司', '天津市可楠钢管有限公司', '天津市宝来工贸有限公司', '河北盛泰制管有限公司', '天津市利达钢管集团有限公司'], // 钢管制造企业
                // ['唐山海翼宏润物流有限公司', '浙江物产物流投资有限公司唐山分公司', '厦门国贸启铭物流有限公司', '唐山市丰领物流有限公司', '四川乐送物流股份有限公司', '河北兴泰物流有限公司', '唐山象屿正丰国际物流有限公司', '唐山市双赢物流有限公司', '邯郸新铁物流有限公司', '唐山东方海运有限公司'], // 钢铁物流企业
                // ['唐山友利焦化有限公司', '武安市广普焦化有限公司', '介休市昌盛煤气化有限公司', '山西安泰集团股份有限公司', '唐山东方炼焦制气有限公司', '乌海市广纳煤焦化有限公司', '河北华丰能源科技发展有限公司', '山西潞宝集团焦化有限公司', '唐山达丰焦化有限公司', '山西亚鑫煤焦化有限公司'], // 焦化生产企业
                // ['秦皇岛顺先钢铁有限公司', '天津市震翔板带加工有限公司', '唐山市丰润区鸿翔金属制品有限公司', '唐山首唐宝生功能材料有限公司', '唐山如隆实业有限公司', '唐山市丰润区鑫通源扁钢厂', '唐山宏润实业有限公司', '唐山市德物精密制品有限公司 ', '江苏卓群金属科技有限公司', '唐山市丰润区永强轧钢厂'], //钢加工企业
                // ['河北津西新材料科技有限公司', '泊头市宝发彩钢钢构工程有限公司', '庆云华兴钢架工程有限公司', '宏德瑞琳金属结构制造有限公司', '邯郸市银蝉贸易有限公司', '潍坊长安铁塔股份有限公司', '天津市鑫跃达工贸有限公司', '邯郸市泽业贸易有限公司', '邯郸市恒特板材加工有限公司', '邯郸市华威钢结构工程有限公司'], // 钢结构生产企业
                // ['本溪市远通物资回收有限公司', '朝阳议通金属再生资源有限公司', '天津城矿再生资源回收有限公司', '武安市永鑫再生资源利用有限公司', '天津德邦（邢台县）再生资源利用有限公司', '扬州鸿蓝钢铁加工有限公司', '天津振泓再生资源有限公司', '天津宏业兴再生物资回收有限公司', '浙商中拓集团江西再生资源有限公司', '河南冀物再生资源有限公司'], // 废钢回收加工企业
                // ['上海东亚期货有限公司', '中辉期货有限公司', '宏源期货有限公司', '徽商期货有限责任公司', '永安期货股份有限公司', '国投安信期货有限公司', '国泰君安期货有限公司', '银河期货有限公司', '国海良时期货有限公司', '中国国际期货股份有限公司'], // 期货企业
                // ['辽宁海力特种石油装备有限公司', '上海鸿网供应链股份有限公司', '中国检验认证集团河北有限公司', '钢谷电子商务股份有限公司', '德邻智联（鞍山）有限公司', '日照大宗商品交易中心', '中瑞和（天津）供应链管理服务有限公司', '唐山曹妃甸实业港务有限公司', '北京恒润九州实业有限公司', '秦皇岛佰工钢铁有限公司'], // 服务企业
                // ['厦门国贸集团股份有限公司', '唐山凯荣国际贸易有限公司', '中航国际钢铁贸易有限公司', '天津锦亿供应链管理有限公司', '嘉吉投资（中国）有限公司', '浙江物产金属集团有限公司', '河钢集团北京国际贸易有限公司', '山东建邦联合进出口有限公司', '山东环富国际贸易有限公司', '日照兴业集团有限公司'], //铁矿石供应商
                // ['唐山和朋贸易有限公司', '山东中垠国际贸易有限公司', '唐山永联国际贸易有限责任公司', '山东冀中瀚能供应链管理有限公司', '唐山市五山商贸有限公司', '厦门象屿股份有限公司', '易大宗（北京）供应链管理有限公司', '山东潍焦集团薛城能源有限公司', '山西省焦炭集团经销贸易有限公司', '重庆喜丰春瑞供应链管理有限公司'], // 煤焦供应商
                // ['天津瑞鑫昌科技有限公司', '河北港济实业有限公司', '河北港禾实业发展有限公司', '浙江开迪贸易有限公司', '江阴市铁实供应链有限公司', '上海俱丰供应链有限公司', '迁安市瑞虎商贸有限公司', '唐山市晨丰商贸有限公司', '天津市仁通钢铁有限公司', '唐山海瀚国际贸易有限公司'], // 钢坯供应商
                // ['唐山市丰润区乔羽贸易有限公司', '山西浩正鸿瑞贸易有限公司', '河北华贸电力新材料有限公司', '宁波荣城金属材料有限公司', '鞍山市鑫华通贸易有限公司', '唐山市丰润区超翼商贸有限公司', '邯郸市裕驰贸易有限公司', '泰安市延峰物资有限公司', '唐山市丰润区建源商贸有限公司', '唐山朗威进出口贸易有限公司'], // 型钢供应商
                // ['汇金工贸（天津）有限公司', '邯郸市钢盈贸易有限公司', '山东新乐华钢铁有限公司', '青岛鸿利宇供应链有限公司', '邯郸市泰虎贸易有限公司', '河北邯城贸易有限公司', '河北泰岳峰钢铁贸易有限公司', '唐山市炳旭实业有限公司', '中船重工物资贸易集团有限公司', '邯郸市晟德贸易有限公司'], // 板材供应商
                // ['辽宁紫中供应链有限责任公司', '河南豫之钢贸易有限公司', '万豪钢铁集团有限公司', '任丘市亚丰建筑器材有限公司', '中铁铁龙（营口）国际物流贸易有限公司', '唐山宏腾贸易有限公司', '陕钢集团韩城钢铁有限责任公司', '福建点增贸易有限公司', '山西兴合邦物资有限公司', '山东蓝天新材料科技有限公司'], // 建材供应商
                // ['天津市仁翼博爱国际商贸有限公司', '无锡市启升金属材料有限公司', '天津市宏英丰达金属材料销售有限公司', '瑞信国际贸易有限公司', '天津市智恒达商贸有限公司', '迁安市瑞虎商贸有限公司', '天津市丰隆商贸有限公司', '天津中拓电子商务有限公司', '上海塔杰实业有限公司', '天津勤兴敬业科技有限公司'], // 带钢供应商
                // ['天津市民阁商贸有限公司', '广州市华利丰钢材贸易有限公司', '南京友发物资有限公司', '奎鑫钢首集团', '唐山市青坤贸易有限公司', '霸州市广义制管有限公司', '天津海翼钢铁销售有限公司', '天津德汇钢铁贸易有限公司', '天津宏盛强钢铁有限公司', '天津市德健钢管有限公司'], // 钢管供应商
            ],
            sjDetailData: []
        }
    },
    mounted () {
        this.id = getQueryString('id');
        // this.getAdByAdp();
        this.marqueeInit();
    },
    methods: {
        // 获取广告信息
        // getAdByAdp () {
        //     const self = this;
        //     self.adIDsIndex.forEach((item, index) => {
        //         self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
        //             if (res.code == 0) {
        //                 self.adIDsIndex[index]['list'] = res.data;
        //             }
        //         })
        //     })
        // },
        marqueeInit () {
            const self = this;
            $('.index-quote-list-box').liMarquee('destroy');
            setTimeout(() => {
                $('.index-quote-list-box').liMarquee({
                    // direction: 'up',
                    // loop: -1,
                    scrollamount: 30,
                    hoverstop: true,
                    circular: false
                });
            }, 500)
            
            
        },
        showImgDetail (index) {
            // console.log('进来了')
            this.dialogImg = this.imgs[index];
            this.sjDetailData = this.imgsDetailNames[index];
            this.dialogVisible = true;
        }
    }
    
}
</script>

<style scoped>
    @import url('../../assets/css/liMarquee.css');
    .content-bg {
        background: url('../../assets/images/ej/activeTopbg.jpg') no-repeat;
        background-size: 100% auto;
        position: relative;
    }
    .logo-position {
        position: absolute;
        top: 60px;
        left: 60px;
        color: #fff;
    }
    .logo-position > p { font-size: 20px; }
    .logo-position > div > span { display: inline-block; margin-bottom: 20px; width: 8px; border-top: 2px solid #fff;}
    .mt10 { margin-top: 10px; }
    .mt40 { margin-top: 40px; }
    .mt30 { margin-top: 30px; }
    .title-text { font-size: 28px; letter-spacing: 10px; }
    .title-text-en { font-size: 20px; letter-spacing: 4px; font-weight: 100;}
    .time-text { 
        background: url('../../assets/images/ej/activeTimebg.png') no-repeat; 
        background-size: 100% 100%;
        line-height: 40px;
        width: 600px;
        font-size: 14px;
        font-weight: 600;
    }
    .meeting-jj {
        background: rgba(0, 0, 0, 0.4);
        font-size: 16px;
        color: #fff;
        line-height: 35px;
        width: 700px;
        padding: 20px 30px;
        letter-spacing: 1px;
        margin-top: 60px;
    }
    .meeting-jj-title {
        font-size: 20px;
        margin-bottom: 10px;
    }
    .meeting-yt {
        margin-top: 60px;
    }
    .meeting-yt-title {
        background: url('../../assets/images/ej/activeTitlebg.png') no-repeat;
        background-size: 100% 100%;
        width: 600px;
        height: 60px;
    }
    .meeting-yt-title span {
        background-image: -webkit-linear-gradient(bottom, #ffc67d, #f6c195, #fbdcbf); 
        -webkit-background-clip: text; 
        -webkit-text-fill-color: transparent;
        line-height: 60px;
        font-size: 30px;
        font-weight: 600;
    }
    .meeting-yc-content {
        width: 1000px;
        box-sizing: border-box;
    }
    .meeting-yc-content > h2 {
        border-left: 10px solid #024e9a;
        padding-left: 20px;
        color: #fff;
    }
    .line { border-top: 1px solid #024e9a; margin-top: 10px; }
    .time-line-content { position: relative; margin-top: 40px; }
    .time-line-content span { display: inline-block; font-size: 16px; vertical-align: top; }
    .point {
        background: url('../../assets/images/ej/activeTimePoint.png') no-repeat;
        background-size: 100% 100%;
        width: 15px;
        height: 15px;
        margin: 0 30px;
        vertical-align: bottom;
        margin-top: 4px;
    }
    .right-text {
        color: #024e9a;
        margin-left: 30px;
        font-weight: 600;
        line-height: 30px;
        margin-top: -5px;
    }
    .time-line-content .right-intro {
        color: #024e9a;
        font-size: 14px;
        line-height: 40px;
    }
    .shuline {
        position: absolute;
        height: 80px;
        border-left: 1px solid #fff;
        top: 20px;
        left: 136px;
    }
    .meeting-jbjs {
        border: 8px solid #0350a0;
        box-sizing: border-box;
        width: 1000px;
        padding: 20px;
        color: #d6be98;
    }
    .detail-user-img { width: 100%; height: 200px;  }
    .index-quote-list-box { width: 1000px; height: 360px; overflow: hidden; box-sizing: border-box; border: 8px solid #0350a0; margin: 30px auto; }
    .index-quote-list-box .img-box { padding: 30px 10px 10px 10px;  }
    .index-quote-list-box p { line-height: 40px; font-size: 16px; color: #d6be98; }
    .meeting-zanzhu { width: 1000px; }
    .zanzhu-title,
    .zanzhu-subtitle { color: #fd7744; font-size: 18px; }
    .zanzhu-subtitle { color: #ffd79f; }
    .zanzhu-left,
    .zanzhu-center,
    .zanzhu-right { line-height: 35px; width: 100%; background: url('../../assets/images/ej/one.png') no-repeat; background-size: 100% 100%; margin: 10px 0; font-size: 14px; color: #fff;}
    .zanzhu-center { background: url('../../assets/images/ej/two.png') no-repeat; background-size: 100% 100%; }
    .zanzhu-right { background: url('../../assets/images/ej/three.png') no-repeat; background-size: 100% 100%; }
    .meeting-address { padding-bottom: 30px; }
    .address-bg {
        background: url('../../assets/images/ej/addressbg.png') no-repeat;
        background-size: 100% 100%;
        padding-top: 50px;
    }
    .address-bg img { width: 1000px; }
    .meeting-concat { width: 1000px; }
</style> 